import * as Actions from './actions/actions';
import reducer from './reducers/index';
import { Store } from 'redux';
import { AlightCustomSettingsType } from '../../settings/alight-custom-settings';
import { Input } from '@alme/ui-web/types/input';
import { AlightStateType } from '../../types/alight-state';

export default class RequestProcessorChatAllowed {
    _settings: AlightCustomSettingsType;
    _store: Store<AlightStateType> | undefined;

    constructor(settings: AlightCustomSettingsType) {
        this._settings = settings;
    }

    getRequestProcessor() {
        return this;
    }

    getReducer() {
        return reducer;
    }

    initialize(store: Store<AlightStateType>) {
        this._store = store;
    }

    getPromise(){
        this.getIsLiveChatAvailable();
        return Promise.resolve();
    }

    process(input: Input){
        let inputParameters: any = {};
        if (input.parameters) {
            inputParameters = input.parameters;
        }

        const isChatAvailable = this._store?.getState().LiveChat.IsChatAvailable;

        inputParameters["isAvailableHours"] = isChatAvailable || this.getIsLiveChatAvailable();

        return Object.assign({}, input, { parameters: inputParameters });
    }

    getIsLiveChatAvailable() {
        let isChatAvailable = false;

        if (window.isChatAvailable)
        {
            const isAvailableHoursResponse = window.isChatAvailable();
            isChatAvailable = isAvailableHoursResponse === true || isAvailableHoursResponse === "true";
        } 

        const payload = 
        {
            stateLocation: `${this._settings.stateLocations.LiveChat.Base}.${this._settings.stateLocations.LiveChat.IsChatAvailable}`,
            value: isChatAvailable,
        };

        this._store?.dispatch(Actions.setIsChatAvailable(payload));

        return isChatAvailable;
    }   //  end getIsLiveChatAvailable()
}



// WEBPACK FOOTER //
// ./modules/request-processor-chat-allowed/request-processor-chat-allowed.ts